<template>
    <!-- NOTIFICATIONS -->
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
        <feather-icon icon="BellIcon" class="cursor-pointer mt-1 sm:mr-6 mr-2" :badge="unreadNotifications.length"/>

        <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

            <div class="notification-top text-center p-5 bg-primary text-white">
                <h3 class="text-white">{{ unreadNotifications.length }} New</h3>
                <p class="opacity-75">App Notifications</p>
            </div>

            <component :is="scrollbarTag" ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0"
                       :settings="settings" :key="$vs.rtl"> <!-- mb-10 -->
                <ul class="bordered-items">
                    <li v-for="(ntf,index) in unreadNotifications" :key="index"
                        class="flex justify-between px-4 py-4 notification cursor-default">
                        <div class="flex items-start">
                            <feather-icon :icon="ntf.icon"
                                          :svgClasses="[`text-${ntf.category}`, 'stroke-current mr-1 h-6 w-6']"></feather-icon>
                            <div class="mx-2">
                                <span class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{ ntf.title }}</span>
                                <small>{{ ntf.message.replace('#STATUS#', ntf.status) }}</small>
                                <small v-if="ntf.link" class="block mt-1"><a :href="ntf.link" target="_blank">Download here</a></small>
                            </div>
                        </div>
                        <small class="mt-1 whitespace-no-wrap">{{ elapsedTime(ntf.updated_at) }}</small>
                    </li>
                </ul>
            </component>

            <!-- <div class="
                checkout-footer
                fixed
                bottom-0
                rounded-b-lg
                text-primary
                w-full
                p-2
                font-semibold
                text-center
                border
                border-b-0
                border-l-0
                border-r-0
                border-solid
                d-theme-border-grey-light
                cursor-pointer">
                <span>View All Notifications</span>
            </div> -->
        </vs-dropdown-menu>
    </vs-dropdown>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'

    export default {
        components: {
            VuePerfectScrollbar
        },
        data() {
            return {
                // unreadNotifications: [
                //     {
                //       index    : 0,
                //       title    : 'New Message',
                //       message      : 'Are your going to meet me tonight?',
                //       icon     : 'MessageSquareIcon',
                //       time     : this.randomDate({sec: 10}),
                //       category : 'primary'
                //     },
                //     { index    : 1,
                //       title    : 'New Order Recieved',
                //       message      : 'You got new order of goods.',
                //       icon     : 'PackageIcon',
                //       time     : this.randomDate({sec: 40}),
                //       category : 'success'
                //     },
                //     { index    : 2,
                //       title    : 'Server Limit Reached!',
                //       message      : 'Server have 99% CPU usage.',
                //       icon     : 'AlertOctagonIcon',
                //       time     : this.randomDate({min: 1}),
                //       category : 'danger'
                //     },
                //     { index    : 3,
                //       title    : 'New Mail From Peter',
                //       message      : 'Cake sesame snaps cupcake',
                //       icon     : 'MailIcon',
                //       time     : this.randomDate({min: 6}),
                //       category : 'primary'
                //     },
                //     { index    : 4,
                //       title    : 'Bruce\'s Party',
                //       message      : 'Chocolate cake oat cake tiramisu',
                //       icon     : 'CalendarIcon',
                //       time     : this.randomDate({hr: 2}),
                //       category : 'warning'
                //     },
                // ],
                settings: {
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },
            }
        },
        computed: {
            scrollbarTag() {
                return this.$store.getters.scrollbarTag
            },
            unreadNotifications() {
                return this.$store.getters.getNotifications
            }
        },
        methods: {
            populateNotifications() {
                /* NOTE: Notifications required format */
                // let notiArr = [
                //     {
                //         title: 'Download Queued',
                //         message: 'Premium Master Table download will shortly begin',
                //         type: 'csv_download',
                //         status: 'pending',
                //         link: null,
                //         updated_at: '2020-06-15 12:04:54',
                //     },
                //     {
                //         title: 'Download Complete',
                //         message: 'Premium Master Table csv ready for download',
                //         type: 'csv_download',
                //         status: 'done',
                //         link: 'http://localhost:8080/premium-master-list.csv',
                //         updated_at: '2020-06-15 13:04:54',
                //     },
                //     {
                //         title: 'Download Failed',
                //         message: 'Premium Master Table csv download failed',
                //         type: 'csv_download',
                //         status: 'error',
                //         link: null,
                //         updated_at: '2020-06-15 14:04:54',
                //     }
                // ];

                this.$axiosSecure.get('/jobs')
                    .then((response) => {
						this.$store.dispatch('setNotifications', response.data.data);
                    })
                    .catch(error  => {
                        // If user is not logged in
                        if (error.response.status == 403) {
							// Token invalid so logout
							this.$root.$emit('appLogout');
						}
                    })
            },
        },
        mounted() {
            // TODO Add time interval 30s to refresh notifications
            this.populateNotifications();

            // Page Download Event
            this.$root.$on('refreshNotifications', () => {
                this.populateNotifications();
            })
        },
        destroyed() {

            // Unbind Event Listeners
            this.$root.$off('refreshNotifications');
        }
    }

</script>

